import React, { FC } from 'react';
import { HStack, IconButton, VStack } from '@chakra-ui/react';
import { Question } from '../types';
import TextLabel from '../../Misc/LText';

interface RangeQuestionProps {
  question: Question;
  onChange: (value: number, question: Question) => void;
}

const RangeQuestion: FC<RangeQuestionProps> = ({
  question,
  onChange,
}) => {
  const maxValue = 5;
  const handleChange = (value: number) => {
    onChange(value, question);
  };

  return (
    <VStack width='full' align='start'>
      <TextLabel title={question.value} />
      <HStack py={2}>
        {Array.from({ length: maxValue }, (_, i) => i + 1).map((value) => (
          <IconButton
            key={value}
            isRound
            aria-label='Range'
            variant='solid'
            size='sm'
            colorScheme={question.response === value ? 'brand' : undefined}
            onClick={() => handleChange(value)}
            icon={<div>{value}</div>}
          />
        ))}
      </HStack>
    </VStack>
  );
};

export default RangeQuestion;
